export const responsive = [
  {
    breakpoint: 400,
    settings: {
      slidesToScroll: 1,
      slidesToShow: 1,
      variableWidth: false,
    },
  },
];
